"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ComposeStyles_1 = require("./ComposeStyles");
var selectComposeFormatOption_1 = require("../actions/selectComposeFormatOption");
var selectShowRecipientWellOption_1 = require("../actions/selectShowRecipientWellOption");
var store_1 = require("../store/store");
var owa_options_controls_1 = require("owa-options-controls");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var styles = require('./MessageFormatFull.scss');
var MessageFormatFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessageFormatFull, _super);
    function MessageFormatFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageFormatFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var showBcc = owa_options_core_1.getFallbackValueIfNull(optionStore.showBcc, userOptions.AlwaysShowBcc);
        var showFrom = owa_options_core_1.getFallbackValueIfNull(optionStore.showFrom, userOptions.AlwaysShowFrom);
        var messageFormat = owa_options_core_1.getFallbackValueIfNull(optionStore.composeFormat, userOptions.ComposeMarkup);
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.showRecipientWellOptions },
                React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: showBcc, label: owa_options_strings_1.default.options_format_showBcc, onChange: this.onShowBccChanged }),
                React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: showFrom, label: owa_options_strings_1.default.options_format_showFrom, onChange: this.onShowFromChanged })),
            React.createElement("div", { className: styles.formatDropDownDiv },
                React.createElement("span", null, owa_options_strings_1.default.options_format_formatLabel_front),
                React.createElement(Dropdown_1.Dropdown, { selectedKey: messageFormat, options: [
                        {
                            key: 'Html',
                            text: owa_options_strings_1.default.options_format_dropdown_html,
                        },
                        {
                            key: 'PlainText',
                            text: owa_options_strings_1.default.options_format_dropdown_plaintext,
                        },
                    ], onChanged: this.onComposeFormatChanged }),
                React.createElement("span", null, owa_options_strings_1.default.options_format_formatLabel_back)),
            React.createElement(ComposeStyles_1.default, null)));
    };
    MessageFormatFull.prototype.onShowBccChanged = function (ev, checked) {
        selectShowRecipientWellOption_1.default('showBcc', checked);
    };
    MessageFormatFull.prototype.onShowFromChanged = function (ev, checked) {
        selectShowRecipientWellOption_1.default('showFrom', checked);
    };
    MessageFormatFull.prototype.onComposeFormatChanged = function (option, index) {
        selectComposeFormatOption_1.default(option.key);
    };
    MessageFormatFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MessageFormatFull);
    return MessageFormatFull;
}(React.Component));
exports.default = MessageFormatFull;
//# sourceMappingURL=MessageFormatFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/components/MessageFormatFull.js
// module id = 5147
// module chunks = 2